export function normalizeCityName(city: string): string {
  const upper = city.trim().toUpperCase();

  // Convert to Title Case
  return upper
    .toLowerCase()
    .split(/[\s-]/)
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(city.includes('-') ? '-' : ' ');
}
